import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ef57fb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "area-title" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "トップページに戻る", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "content has-background-contents shadow" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = { class: "navigation" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 送信した資料に戻る ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JobInfoVue = _resolveComponent("JobInfoVue")!
  const _component_JobItemVue = _resolveComponent("JobItemVue")!
  const _component_DssIcon = _resolveComponent("DssIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.collectionDate) + "にした送信", 1),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/dms/outer'))),
        onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.router.push('/dms/outer')), ["prevent"]), ["space","enter"]))
      }, _hoisted_4, 32)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_JobInfoVue, { jobInfo: _ctx.jobInfo }, null, 8, ["jobInfo"]),
      _hoisted_6,
      _createVNode(_component_JobItemVue, { jobItem: _ctx.jobItem }, null, 8, ["jobItem"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push('/dms/outer/list'))),
        onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.router.push('/dms/outer/list')), ["prevent"]), ["space","enter"])),
        class: "button-toList"
      }, [
        _createElementVNode("a", null, [
          _createVNode(_component_DssIcon, { icon: 'arrow-left' }),
          _hoisted_8
        ])
      ], 32)
    ])
  ], 64))
}